import { combineReducers } from 'redux';
import { titleize } from '../utils';

const byId = (state = { payRates: [] }, { type, payload }) => {
  switch (type) {
    case 'PAY_RATE_LIST_SUCCESS':
      return {
        ...state,
        payRates: payload.pay_rates,
      };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  currentRate: '',
  showingHistoryScreen: false,
};

const common = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case 'SHOW_RATE_HISTORY':
      return {
        ...state,
        currentRate: payload.rate,
        showingHistoryScreen: true,
      };
    case 'HIDE_RATE_HISTORY':
      return {
        ...state,
        currentRate: '',
        showingHistoryScreen: false,
      };
    case 'PAY_RATE_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'PAY_RATE_LIST_SUCCESS':
      return {
        ...state,
        currentRate: meta.rate,
        loading: false,
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
});

export const getCurrentHistoryList = state => (
  state.byId.payRates
);

export const getLoading = state => state.common.loading;
export const getShowHistory = state => state.common.showingHistoryScreen;
export const getCurrentName = state => titleize(state.common.currentRate);



// WEBPACK FOOTER //
// ./client/app/reducers/pay_rates.js